export const FETCH_PRICING_ITEMS_OPERATION_NAME = 'fetchPricingItems'
export const RELOAD_DISCOUNTS_OPERATION_NAME = 'fetchDiscounts'
export const REFRESH_PRICING_NUM_RETRIES = 4
export const DEBOUNCE_INTERVAL = 400
